// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs-card[data-v-32cb4556]{width:25%;padding:.75rem}@media screen and (max-width:768px){.vs-card[data-v-32cb4556]{min-width:8em}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
